import { EVENT_NAMES } from './../../utils/events'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import { v4 as uuidv4 } from 'uuid'
import { AuthenticateResponse } from '../../interfaces/authenticate-response'
import { OnIsClientResponse } from '../../interfaces/on-is-client-response'

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
})
export class LoginLayoutComponent implements OnInit, OnDestroy {
  flowProduct: string = ''
  processProduct: string = ''
  isClient: OnIsClientResponse | undefined = undefined
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(private router: Router, private route: ActivatedRoute) { }

  private handleOnAuthenticate = (event: Event) => {
    /*
    NOTE: not sure why facephi path persists in session storage.
    This is a workaround.
    */
    this.storage.remove(EVENT_NAMES.facephiPath)

    const { detail } = event as CustomEvent<AuthenticateResponse>
    this.isClient = this.isClient ?? this.storage.get('onb-mfa-login:-on-is-client')
    if (detail?.error) return
    if (
      this.isClient &&
      typeof this.isClient.data.client === 'boolean' &&
      typeof this.isClient.data.update === 'boolean'
    ) {
      //is client must return values
      if (this.isClient.data.client && this.isClient.data.update && 'url' in detail.data) {
        //updated clients redirect by url
        this.storage.set(EVENT_NAMES.auth, detail.data)
        this.handleUrlData(detail.data.url)
      } else if (
        !this.isClient.data.client ||
        (!this.isClient.data.update && this.isClient.data.client)
      ) {
        //not updated client or no client
        this.handleClientData(detail.data)
      }
    }
  }

  private handleOnIsClient = (event: Event) => {
    const { detail } = event as CustomEvent<any>
    if (detail?.error) {
      if ((detail.error.code === "307" && detail.error.message === 'Servicio fuera de horario')) {
        this.router.navigate([this.flowProduct, this.processProduct, 'fuera-oficina'], { replaceUrl: true })
      }
    }
  }

  public setOnIsClient(value: OnIsClientResponse) {
    this.isClient = value
    this.storage.set('onb-mfa-login:-on-is-client', value)
  }

  private handleUrlData(url: string) {
    const urlPath = new URL(url).pathname.split('/').slice(1)
    this.router.navigate(urlPath)
  }

  private handleClientData(data: any) {
    const isFlexible = this.flowProduct === 'flexible'
    const isCRM = this.processProduct === 'asistido'
    let clientRoute = 'prospecto'

    if (this.isClient?.data.client && this.isClient?.data.update) {
      clientRoute = 'cliente'
    } else if (this.isClient?.data.client && !this.isClient?.data.update) {
      clientRoute = 'cliente-na'
    }

    if (isCRM) {
      //crm must be athuenticated without facephi
      this.storage.set(EVENT_NAMES.auth, data)
      if (isFlexible && clientRoute === 'prospecto') {
        this.router.navigate(['redireccion'])
      } else {
        this.router.navigate([this.flowProduct, this.processProduct, clientRoute, 'validacion'], { replaceUrl: true })
      }
    } else if (isFlexible) {
      clientRoute === 'prospecto'
        ? this.router.navigate(['redireccion'])
        : this.router.navigate([clientRoute, 'foto'], { relativeTo: this.route })
    } else {
      this.router.navigate([clientRoute, 'foto'], { relativeTo: this.route })
    }
  }

  ngOnInit(): void {
    this.storage.clear()

    const flow = this.router.url.split('/')[1]
    this.flowProduct = flow
    const process = this.router.url.split('/')[2]?.split('?')[0]
    this.processProduct = process
    const utm = this.router.url.split('?')[1]

    this.storage.set(EVENT_NAMES.headers, {
      'x-guid': uuidv4(),
      'x-flow': flow,
      'x-app-version': flow === 'flexible' ? 'new_' : ' ',
      'x-process': process,
      'x-utm': utm,
    })
    this.storage.set(EVENT_NAMES.loginConfig, { flow, process })

    window.addEventListener(EVENT_NAMES.loginOnAuthenticate, this.handleOnAuthenticate)
    window.addEventListener(EVENT_NAMES.onIsClient, this.handleOnIsClient)
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.loginOnAuthenticate, this.handleOnAuthenticate)
    window.removeEventListener(EVENT_NAMES.onIsClient, this.handleOnIsClient)
  }
}
